import { useEffect, useRef } from "react";
import UIkit from "uikit";
import { openGuidePhotoViewer } from "../../utils/guidePhotoViewer";

export default function GuidePhotoPreview({ photos, title }) {
  const viewer = useRef(null);
  const photoUrls = photos.map((photo) => photo.url).join("\n");
  useEffect(() => () => {
    viewer.current?.hide();
    viewer.current = null;
  }, [photoUrls]);
  const showPhoto = (index, trigger) => {
    if (viewer.current) return;
    const panel = openGuidePhotoViewer(window.UIkit || UIkit, photos.map((photo) => ({
      url: photo.url, alt: photo.original_name || title,
    })), index, trigger, () => {
      if (viewer.current === panel) viewer.current = null;
    });
    viewer.current = panel;
  };
  return (
    <div className="uk-margin-top" style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))", gap: 12 }}>
      {photos.map((photo, index) => (
        <button
          key={photo.id || photo.url}
          type="button"
          aria-label={`View ${title || "block"} photo ${index + 1} of ${photos.length}`}
          onClick={(event) => { event.stopPropagation(); showPhoto(index, event.currentTarget); }}
          style={{ border: 0, padding: 0, background: "transparent", cursor: "zoom-in", borderRadius: 6, overflow: "hidden", aspectRatio: "4 / 3" }}
        >
          <img src={photo.url} alt={photo.original_name || title} loading="lazy" style={{ display: "block", width: "100%", height: "100%", objectFit: "cover" }} />
        </button>
      ))}
    </div>
  );
}
